/**
 * Discussion comment card.
 */
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import Buffer from "buffer";
import { Box } from "@mui/material";
import { Icon } from "@iconify/react";

import { VButton, VFroala } from "form";
import { actionCreateComment } from "context/action";
import { useAsterController } from "context";
import { getSectionTitle, getSequenceTitle, getVerticalTitle } from "utils/course";

if (typeof window.Buffer === "undefined") {
  window.Buffer = Buffer.Buffer;
}

/**
 * Displays a comment composer for the current discussion.
 *
 * @param {{ discussionId?: string }} props
 */
function CommentCard(props) {
  const { t } = useTranslation("common");
  const { discussionId } = props;
  const { courseId, sectionIndex, sequenceIndex, verticalIndex } = useParams();

  const [controller, dispatch] = useAsterController();
  const { user, structure } = controller;

  const [inputText, setInputText] = useState("");

  /**
   * Posts a new discussion comment from the editor.
   *
   * @returns {void}
   */
  const onSubmit = () => {
    if (inputText && discussionId) {
      if (inputText.length)
        actionCreateComment(dispatch, {
          author_name: user.username,
          author_fullname: `${user.first_name} ${user.last_name}`.trim(),
          visible: true,
          course_id: courseId,
          discussion_id: discussionId,
          course_title: structure.course_title,
          section_title: getSectionTitle(structure, sectionIndex),
          sequence_title: getSequenceTitle(structure, sectionIndex, sequenceIndex),
          vertical_title: getVerticalTitle(structure, sectionIndex, sequenceIndex, verticalIndex),
          body: inputText,
          files: [],
        });
      setInputText("");
    }
  };

  return (
    <Box className="shadow-lg rounded-xl">
      <Box className="relative" id="v-froala-container">
        <VButton onClick={onSubmit} className="absolute right-4 top-1.5 z-10 gap-1" variant="contained" disabled={!inputText.length}>
          <Icon icon="akar-icons:arrow-forward-thick" />
          {t("Send")}
        </VButton>

        <Box className="w-full v-child-p">
          <VFroala model={inputText} setModel={setInputText} maxCount={500} className="outline-0 border-0 flex-1" />
        </Box>
      </Box>
    </Box>
  );
}

export default CommentCard;
